module.exports = __webpack_public_path__ + "img/box.35b34833.svg";